/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_User_Roles_InvalidInputs */

const en_error_user_roles_invalid = /** @type {(inputs: Error_User_Roles_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These roles cannot be given as they are: correct the ones marked.`)
};

/**
* | output |
* | --- |
* | "These roles cannot be given as they are: correct the ones marked." |
*
* @param {Error_User_Roles_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_user_roles_invalid = /** @type {((inputs?: Error_User_Roles_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_User_Roles_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_user_roles_invalid(inputs)
});